import React from 'react';

import './QualitativeTypes.css';
import Banner from '../../b2b-common/Banner';
import QualitativeTypesTable from '../components/QualitativeTypesTable';

const QualitativeTypes = () => {

    return (
        <div className='list-qualitative-types-container'>
            <Banner message="Indicators Menu: List qualitative types." />
            <QualitativeTypesTable
                className="qualitative-types-table"
                numRows={10}
            />
        </div>
    );
};

export default QualitativeTypes;